import bigInt from "big-integer";
import { customAlphabet } from 'nanoid'

export function base63_decode(str: string): string {
    const base =
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_";
    if (str.length <= 8) {
        let ret = 0;
        const n = str.length;
        for (let i = 0; i < n; i++) {
            const index = base.indexOf(str.charAt(i));
            ret = ret * 63 + (index >= 0 ? index : 0);
        }
        return `${ret}`;
    }
    let ret = bigInt(0);
    const n = str.length;
    for (let i = 0; i < n; i++) {
        const index = base.indexOf(str.charAt(i));
        ret = ret.times(63).plus(index >= 0 ? index : 0);
    }
    return `${ret}`;
}

export function base63_encode(number: string): string {
    const base =
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_";
    let ret = "";
    let int = bigInt(number);
    while (int.compareTo(0) > 0) {
        ret = `${base[int.mod(63).toJSNumber()]}${ret}`;
        int = bigInt(int.divide(63));
    }
    if (ret.indexOf("_") < 0 && ret.length !== 8) {
        while (ret.length < 8) {
            ret = `0${ret}`;
        }
    }
    return ret;
}
export function generateDetailPath(doc_id: string, title: string) {
    const id = base63_decode(doc_id);
    // 移除所有emoji表情，并将空格替换为短横线
    //@ts-ignore
    const slug = title
        // 移除emoji表情符号
        .replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, '')
        // 移除零宽度字符 (ZWJ, ZWNJ, variation selectors等)
        .replace(/[\u200D\u200C\uFE0F\uFE0E]/g, '')
        // 移除其他变体选择器和组合标记
        .replace(/[\u{E0000}-\u{E007F}]/gu, '')
        // 将全角标点符号转换为半角
        .replace(/？/g, '?')
        .replace(/！/g, '!')
        .replace(/，/g, ',')
        .replace(/。/g, '.')
        .replace(/：/g, ':')
        .replace(/；/g, ';')
        .replace(/"/g, '"')
        .replace(/"/g, '"')
        .replace(/'/g, "'")
        .replace(/'/g, "'")
        // 移除其他可能problematic的字符
        .replace(/[^\w\s\-.,!?:;'"()]/g, '')
        // 将空格替换为短横线
        .replace(/\s+/g, '-')
        // 移除多余的短横线
        .replace(/-+/g, '-')
        // 移除开头和结尾的短横线
        .replace(/^-+|-+$/g, '')
        // 移除对URL解析有影响的字符（如 ? # / & = % 等）
        .replace(/[?#\/&=%]/g, '');
    let path = `${id}-${slug}`;
    if (path.endsWith("-")) {
        path = path.slice(0, -1);
    }
    return path;
}

export function getDocIdFromSlug(slug: string): string {
    const id = base63_encode(slug.split("-")[0]);
    return id;
}

const nanoid = customAlphabet('123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ', 32)

export function generateUniqueId(num: number = 32) {
    return nanoid(num);
}

/**
 * 服务端设备检测函数
 * @param userAgent - 来自请求头的 User-Agent
 * @returns 设备类型信息
 */
export function detectDevice(userAgent: string) {
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;
    const tabletRegex = /iPad|Android(?=.*Tablet)|tablet/i;

    const isMobile = mobileRegex.test(userAgent);
    const isTablet = tabletRegex.test(userAgent);
    const isDesktop = !isMobile && !isTablet;

    return {
        isMobile,
        isTablet,
        isDesktop,
        userAgent
    };
}

/**
 * 从 headers 获取 User-Agent 并检测设备
 */
export function getDeviceFromHeaders(headers: Headers) {
    const userAgent = headers.get('user-agent') || '';
    return detectDevice(userAgent);
}

/**
 * 格式化数字显示（如 1234 -> 1.2K）
 * @param num - 要格式化的数字
 * @returns 格式化后的字符串
 */
export function formatNumber(num: number): string {
    if (Number.isNaN(num) || num === undefined) {
        return '';
    }
    if (num < 1000) {
        return num.toString();
    }

    if (num < 1000000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }

    if (num < 1000000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }

    return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
}
export function isIOS(userAgent: string) {
    return /iPad|iPhone|iPod/.test(userAgent);
}
export function isAndroid(userAgent: string) {
    return /Android/i.test(userAgent);
}